// extracted by mini-css-extract-plugin
export default {"draggableItem":"Review_draggableItem__EFwmE"};